import axios from "axios";
import {
  AddressTokentransfer,
  AddressTokentranstion,
  AllBlock,
  AllTransactions,
  LatestTransactions,
  Latestblocks,
  TaransationTokentranst,
  TokenTransactionS,
  Tokentransfer,
  Tokentranst,
  Tokentranstion,
  TopToken,
  blockTransaction,
  internaltx,
  logs,
  tokeninternaltx,
  tokentransaction,
  tokentransaction2,
  tokentransfer,
} from "../Shared/Structre";
// const URL = "https://trace-scanner-api-356852023.azurewebsites.net";
// const URL = "http://localhost:9798";
// const URL="http://103.125.70.205:5062"; //live
// const URL = "http://192.168.2.157:8080";
// const URL = "http://103.125.70.205:9798";
const URL = process.env.REACT_APP_API_URL;
//process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: URL,
});

export const getLatestTransaction = () => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        URL + "/v1/transaction/LatestTransactions?&limit=8",
        LatestTransactions,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getLatestBlock = () => {
  return new Promise((resolve, reject) => {
    axios
      .post(URL + "/v1/block/LatestBlocks?&limit=8", Latestblocks)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getBlockheight = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(URL + "/v1/block/LatestHeight")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTransctionCount = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(URL + "/v1/stats/getTXCount")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getWOOOOPrice = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(URL + "/v1/stats/getWOOOOPrice")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getAllTransaction = (pageNumber, pageSize, pricesorder) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(
        `/v1/transaction?pageNumber=${pageNumber}&pageSize=${pageSize}&Priceorder=${pricesorder}`,
        AllTransactions,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getAllBlock = (pageNumber, pageSize) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/block?pageNumber=${pageNumber}&pageSize=${pageSize} `,
        AllBlock,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const GetTotalBlocks = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/stats/getBlocksCount`)
      .then((x) => {
        resolve(x);
      })
      .catch((x) => {
        reject(x);
      });
  });
};
export const getTopToken = (pageNumber, pageSize) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/token/getAllCoins?pageNumber=${pageNumber}&pageSize=${pageSize}&coinname=${""}`,
        TopToken,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTokentranfer = (pageNumber, pageSize) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/token/alltokentransfer?pageNumber=${pageNumber}&pageSize=${pageSize} `,
        tokentransfer,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getDetailTransaction = (transactionId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/transaction/${transactionId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getInternalTransaction = (transactionId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/transaction/internalTransaction/${transactionId}`,
        internaltx,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getlogsTransaction = (transactionId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/transaction/logs/${transactionId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTokentransfer = (transactionId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/token/tokentransfer/${transactionId}`,
        TaransationTokentranst,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getDetailBlock = (blocknumber) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/block/${blocknumber}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getBlockTransaction = (blocknumber) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/block/blockTransaction/${blocknumber}`, blockTransaction)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getAddressTransaction = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/account/${address}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTokendetail = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/v1/token/getCoinbyTx/${address}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getAdressTransaction = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/transaction/addressTransaction/${address}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTokenTransaction = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/token/addressTokens/${address}`, Tokentranstion)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getAddressTokentransfer = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/token/tokentransfer/${address}`, AddressTokentranstion)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const TransactionGraph = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(URL + "/v1/transaction/transaction/graph")
      .then((x) => {
        resolve(x);
      })
      .catch((x) => {
        reject(x);
      });
  });
};

export const TokenTransaction = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/transaction/addressTransaction/${address}`,
        TokenTransactionS,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const Tokeninternaltx2 = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/stats/intenalTransactin/${address}`, tokeninternaltx)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const coinTokentransfer = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/token/tokentransfer/${address}`, tokentransaction2)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const TokenTransact = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${URL}/v1/token/addressTokens/${address}`, Tokentranst)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const TokentransferAdrees = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${URL}/v1/transaction/addressTransaction/${address}`,
        AddressTokentransfer,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// export const SearchBar = (search, endpoint, type) => {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(endpoint)
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

// export const fetchResults = (search, endpoint, type) => {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(search)
//       .then((response) => {

//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };
